module.exports = __webpack_public_path__ + "static/media/icon-twitter.810ccee8.svg";